import { useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { defaultBid } from '@bingads-webui-campaign-legacy/budget/shared/defaultBid';

export const useCurrencyCode = () => {
  const serverContext = useContext(ServerContext);
  const currencyCode = (serverContext && serverContext.CurrentAccount && serverContext.CurrentAccount.CurrencyCode) || 'USD';
  return currencyCode;
};

export const useDefaultBid = () => defaultBid();
